import { Avatar, Stack, Typography } from '@mui/material';
import { EntitlementsContext } from 'Context/CompassRightsContext/EntitlementsProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { BlueX, WhiteX } from 'Images';
import { useContext } from 'react';
import { onEnterOrEscapeKeyDown } from 'Utils/accessibilityOnKeyDown';

interface ISelectedFilters {
  id: number;
  name: string;
  mainCategory: {
    id: number;
    name: string;
  };
}

export const SelectedFilter = ({
  id,
  name,
  mainCategory,
}: ISelectedFilters) => {
  const { categories, dispatchCategories, dispatchEntitlements } =
    useContext(EntitlementsContext);
  const isDesktop = useIsDesktop();

  const RemoveFilterHandler = () => {
    dispatchCategories({
      type: 'REMOVE_SINGLE_SUB_CATEGORY',
      payload: {
        value: {
          mainCategoryID: mainCategory.id,
          subCategoryID: id,
        },
      },
    });
    dispatchEntitlements({
      type: 'FILTER_CATEGORIES',
      payload: { value: categories },
    });
  };

  return (
    <Stack
      direction='row'
      width='fit-content'
      alignItems='center'
      bgcolor='purple2.main'
      padding='6px 10px 6px 5px'
      gap='8px'
      borderRadius='6px'
      sx={{ cursor: 'pointer' }}
      onClick={RemoveFilterHandler}
      onKeyDown={(event) => onEnterOrEscapeKeyDown(event)}
      tabIndex={0}
      height={isDesktop ? '34px' : '32px'}
    >
      <Avatar
        alt={Dictionary[DICTIONARY.CompassRights].clearSingleSelection}
        src={WhiteX}
        sx={{ width: '30px', height: '30px' }}
      />
      <Typography variant={'body6'} color={'#fff'} whiteSpace='nowrap'>
        {mainCategory.name + ' - ' + name}
      </Typography>
    </Stack>
  );
};
